export enum StepState {
    UNCOMPLETED,
    INPROGRESS,
    COMPLETED
}

export interface Step {
    id: string;
    slug: string;
    displayTitle: string;
    order: number;
    icon: any;
    includeOrderSummary: boolean;
    state: StepState;
}
